import AnchorLink from "react-anchor-link-smooth-scroll"
import React from "react"
import { Link } from "gatsby"

import ButtonSubmit from "../../components/Button"
import Container from "../../components/UI/Container"
import Heading from "../../components/Heading"
import Logo from "../../common/assets/image/alpacked/logo.svg"
import Text from "../../components/Text"
import BannerWrapper, { BannerContent } from "./ebookheader.style"

const EBookHeader = () => {
  return (
    <BannerWrapper>
      <Container width="1340px">
        <Link to="/">
          <img src={Logo} alt="logo" className="logo" />
        </Link>
      </Container>
      <Container width="1340px">
        <BannerContent>
          <Text content="eBook:" className="intro" />
          <hr />
          <Heading as="h1" content="DevOps-as-a-Service:" />
          <Text content="Costs, Teams, & Philosophy" className="subtitle" />
          <Text
            content=" In our free eBook, you will learn best practices and roadmaps to implement DevOps into your processes. Also, you’ll find price estimates and comparisons of having an in-house team vs DaaS model, uncover key DevOps benefits, industry trends, and market insights.
"
            className="text"
          />
          <AnchorLink className="excerptLink" href="#contact" offset="60">
            <ButtonSubmit title="DOWNLOAD NOW" />
          </AnchorLink>
        </BannerContent>
      </Container>
    </BannerWrapper>
  )
}

export default EBookHeader
